"use client";

import Image from "next/image";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';

type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};

type Props = {
  category?: FieldConfig;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  imageMetadata?: ImageMetadata;
};

export default function HorizontalBigVideoNews({
  title = { hidden: false, value: "'கடின கதோரி அண்டகடஹம்' திரைப்பட விமர்சனம்: வெகு தொனலியில் இல்லாத கடந்த காலத்திலிருந்து உணர்ச்சியை", customClass: "" },
  excerpt = { hidden: false, value: "நாட்டின் நிலக்கரி உற்பத்தி 2023 ஏப்ரலில் 8.5 சதவீதம் அதிகரித்து 7.314 கோடி டன்னாக", customClass: "" },
  timeAgo = { hidden: false, value: "15 min ago", customClass: "" },
  imageSrc = { hidden: false, value: FALLBACK_IMAGE, customClass: "" },
  slug,
  imageMetadata,
}: Props) {
  const titleValue = title?.value || "";
  const imageSrcValue = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;

  const content = (
    <article className="bg-F8F8F8 overflow-hidden p-4 mb-0">
      <div className="flex flex-col md:flex-row gap-4">
        {/* LEFT: IMAGE */}
        {!imageSrc?.hidden && (
          <div className={`w-full md:w-5/12 lg:w-2/5 shrink-0 ${imageSrc?.customClass || ""}`}>
            <div className="relative w-full min-h-[230px] overflow-hidden">
              <Image
                src={imageSrcValue}
                alt={titleValue}
                fill
                className="object-cover w-full h-full"
                style={getFocusPointStyle(imageMetadata)}
                sizes="(max-width: 768px) 100vw, 40vw"
                loading="lazy"
                placeholder="blur"
                blurDataURL={BLUR_PLACEHOLDER}
              />
            </div>
          </div>
        )}

        {/* RIGHT: CONTENT */}
        <div className="flex flex-col justify-between lg:min-h-[230px] w-full">
          {/* Top Content */}
          <div className="flex flex-col gap-3">
            {!title?.hidden && (
 <h3 className={`text-24-tamil-700 md:text-14text-12-tamil-400 text-FFFFFF leading-[1.6] -tamil-700 text-012061 font-medium leading-[1.4] ${title?.customClass || ""}`}>
                {titleValue}
              </h3>
            )}
          </div>
        </div>
      </div>
    </article>
  );

  if (slug) {
    return (
      <Link href={`/${slug}`} className="block hover:bg-gray-100 transition-colors cursor-pointer">
        {content}
      </Link>
    );
  }

  return content;
}
